import React from 'react';
import {COLORS, FONTS, SIZES, Typography} from '@fupa/fupa-uikit';
import styled from 'styled-components';

const Wrapper = styled.footer`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  background-color: #ffd200;
  padding: ${SIZES['32']};
`;

const LogoWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: ${SIZES['16']};
`;

const Logo = styled.div`
  padding: 0 ${SIZES['16']};
`;

const References = styled.nav`
  display: flex;
  width: 100%;
  justify-content: center;
`;

const Link = styled.a`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

const StyledTypography = styled(Typography)`
  &&& {
    color: ${COLORS.black};
    padding: 0 ${SIZES['4']};
    line-height: ${SIZES['24']};
    font-size: ${FONTS['10']};
  }
`;

const Footer = () => {
  return (
    <Wrapper>
      <LogoWrapper>
        <Logo>
          <img src='FuPa_Logo.svg' height={64} alt='FuPa-Logo' />
        </Logo>
        <Logo>
          <img src='interwetten.svg' height={64} alt='Interwetten-Logo' />
        </Logo>
      </LogoWrapper>
      <References>
        <Link href='https://www.fupa.net/about/legal-notice/profis'>
          <StyledTypography variant='caption1'>Impressum</StyledTypography>
        </Link>
        <Link href='https://www.fupa.net/about/privacy-policy'>
          <StyledTypography variant='caption1'>Datenschutz</StyledTypography>
        </Link>
        <StyledTypography variant='caption1'>&copy; 2022 FuPa GmbH</StyledTypography>
      </References>
    </Wrapper>
  );
};

export {Footer};
